<template>
  <div class="pa-5 ma-1 mb-5 pt-10 page-card">
    <v-row>
      <v-col class="ml-0">
        <span class="display-1 font-weight-black ml-5">DASHBOARD</span>
      </v-col>
      <v-col class="d-flex justify-end">
        <v-btn color="primary" outlined rounded class="mb-7 pl-5 pr-5">
          <v-icon left small>mdi-cached</v-icon>Refresh
        </v-btn>
      </v-col>
    </v-row>

    <v-row class="justify-center align-center">
      <v-col :lg="4" :md="4" :sm="8" cols="12" class="pa-3">
        <div class="stat-num stat-num-top px-1">
          <v-col class="d-flex py-0">
            <v-icon class="mr-1 white--text" large>account_circle</v-icon>
            <v-col>
              <v-col class="pa-0">TOTAL STUDENTS</v-col>
              <v-col class="pa-0">(ผู้เข้าเรียน)</v-col>
            </v-col>
          </v-col>
          <v-row class="d-flex align-end mx-1 font-weight-light">
            <v-col>
              <v-icon class="white--text mr-1">trending_up</v-icon>30%
            </v-col>
            <v-col class="text-end pt-0 font-weight-light headline">3.6K users</v-col>
          </v-row>
        </div>
      </v-col>
      <v-col :lg="4" :md="4" :sm="8" cols="12" class="pa-3">
        <div class="stat-num stat-num-top px-1">
          <v-col class="d-flex py-0">
            <v-icon class="mr-1 white--text" large>visibility</v-icon>
            <v-col>
              <v-col class="pa-0">WATCHING</v-col>
              <v-col class="pa-0">(กำลังรับชม)</v-col>
            </v-col>
          </v-col>
          <v-row class="d-flex align-end mx-1 font-weight-light">
            <v-col>
              <v-icon class="white--text mr-1">trending_up</v-icon>30%
            </v-col>
            <v-col class="text-end pt-0 font-weight-light headline">2.5K users</v-col>
          </v-row>
        </div>
      </v-col>
      <v-col :lg="4" :md="4" :sm="8" cols="12" class="pa-3">
        <div class="stat-num stat-num-top px-1">
          <v-col class="d-flex py-0">
            <v-icon class="mr-1 white--text" large>question_answer</v-icon>
            <v-col>
              <v-col class="pa-0">COMMENT</v-col>
              <v-col class="pa-0">(ข้อความ)</v-col>
            </v-col>
          </v-col>
          <v-row class="d-flex align-end mx-1 font-weight-light">
            <v-col>
              <v-icon class="white--text mr-1">trending_up</v-icon>30%
            </v-col>
            <v-col class="text-end pt-0 font-weight-light headline">10K users</v-col>
          </v-row>
        </div>
      </v-col>
    </v-row>

    <!-- Check Name -->
    <v-row class="justify-center align-center">
      <v-col :lg="4" :md="4" :sm="8" cols="12" class="pa-3">
        <div class="stat-num stat-num-top px-1">
          <v-col class="d-flex py-0">
            <v-icon class="mr-1 white--text" large>library_add_check</v-icon>
            <v-col>
              <v-col class="pa-0">CHECK NAME</v-col>
              <v-col class="pa-0">(การเช็คชื่อ)</v-col>
            </v-col>
          </v-col>
          <v-row class="d-flex align-end mx-1 font-weight-light">
            <v-col>
              <v-icon class="white--text mr-1">trending_up</v-icon>30%
            </v-col>
            <v-col class="text-end pt-0 font-weight-light headline">2 times</v-col>
          </v-row>
        </div>
      </v-col>
      <v-col :lg="4" :md="4" :sm="8" cols="12" class="pa-3">
        <div class="stat-num stat-num-top px-1">
          <v-col class="d-flex py-0">
            <v-icon class="mr-1 white--text" large>comment</v-icon>
            <v-col>
              <v-col class="pa-0">ANSWERING QUESTION</v-col>
              <v-col class="pa-0">(การตอบคำถาม)</v-col>
            </v-col>
          </v-col>
          <v-row class="d-flex align-end mx-1 font-weight-light">
            <v-col>
              <v-icon class="white--text mr-1">trending_up</v-icon>30%
            </v-col>
            <v-col class="text-end pt-0 font-weight-light headline">7K answers</v-col>
          </v-row>
        </div>
      </v-col>
      <v-spacer></v-spacer>
    </v-row>

    <!-- INDIVIDUAL GRAPH -->
    <v-row class="align-center justify-center">
      <v-col :lg="12" :md="12" :sm="12" cols="12" class="pa-3">
        <v-col class="graph-card pa-3">
          <v-col class="pr-2">
            <span class="headline font-weight-light">Total Students (ผู้เข้าเรียน)</span>
          </v-col>
          <apexchart
            type="area"
            height="270"
            :options="attendenceChartOptions"
            :series="attendenceSeries"
          ></apexchart>
        </v-col>
      </v-col>
    </v-row>
    <v-row class="align-center justify-center">
      <v-col :lg="12" :md="12" :sm="12" cols="12" class="pa-3">
        <v-col class="graph-card pa-3">
          <v-col class="pr-2">
            <span class="headline font-weight-light">Online Users (คนออนไลน์)</span>
          </v-col>
          <apexchart
            type="area"
            height="270"
            :options="attendenceChartOptions"
            :series="attendenceSeries"
          ></apexchart>
        </v-col>
      </v-col>
    </v-row>
     <v-row class="align-center justify-center">
      <v-col :lg="12" :md="12" :sm="12" cols="12" class="pa-3">
        <v-col class="graph-card pa-3">
          <v-col class="pr-2">
            <span class="headline font-weight-light">New Users (ผู้เรียนใหม่)</span>
          </v-col>
          <apexchart
            type="area"
            height="270"
            :options="attendenceChartOptions"
            :series="attendenceSeries"
          ></apexchart>
        </v-col>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";

export default {
  components: {
    apexchart: VueApexCharts
  },

  data() {
    return {
      slug: "",
      data: [],

      startDateTime: "",
      endDateTime: "",

      avgCompleted: 80,

      courses: ["All Courses", "English", "Math", "Physics"],
      selectedCourse: "All Courses",

      attendenceSeries: [
        {
          name: "Num of Students",
          data: [
            10,
            50,
            20,
            100,
            40,
            60,
            80,
            10,
            50,
            20,
            100,
            40,
            60,
            80,
            10,
            50,
            20,
            100,
            40,
            60,
            80,
            10,
            50,
            20
          ]
        }
      ],
      attendenceChartOptions: {
        chart: {
          type: "area",
          stacked: false,
          height: 350,
          zoom: {
            type: "x",
            enabled: true,
            autoScaleYaxis: true
          },
          toolbar: {
            autoSelected: "zoom"
          }
        },
        dataLabels: {
          enabled: false
        },
        markers: {
          size: 0
        },
        title: {
          text: "",
          align: "left"
        },
        colors: ["#61dafb"],
        fill: {
          type: "gradient",
          gradient: {
            shadeIntensity: 1,
            inverseColors: false,
            opacityFrom: 0.5,
            opacityTo: 0.5,
            stops: [0, 90, 100]
          }
        },
        yaxis: {
          labels: {
            formatter: function(val) {
              return val;
            }
          },
          title: {
            text: "Num of Students"
          }
        },
        xaxis: {
          type: "datetime",
          categories: [
            "2018-09-19T00:00:00.000Z",
            "2018-09-19T01:00:00.000Z",
            "2018-09-19T02:00:00.000Z",
            "2018-09-19T03:00:00.000Z",
            "2018-09-19T04:00:00.000Z",
            "2018-09-19T05:00:00.000Z",
            "2018-09-19T06:00:00.000Z",
            "2018-09-19T07:00:00.000Z",
            "2018-09-19T08:00:00.000Z",
            "2018-09-19T09:00:00.000Z",
            "2018-09-19T10:00:00.000Z",
            "2018-09-19T11:00:00.000Z",
            "2018-09-19T12:00:00.000Z",
            "2018-09-19T13:00:00.000Z",
            "2018-09-19T14:00:00.000Z",
            "2018-09-19T15:00:00.000Z",
            "2018-09-19T16:00:00.000Z",
            "2018-09-19T17:00:00.000Z",
            "2018-09-19T18:00:00.000Z",
            "2018-09-19T19:00:00.000Z",
            "2018-09-19T20:00:00.000Z",
            "2018-09-19T21:00:00.000Z",
            "2018-09-19T22:00:00.000Z",
            "2018-09-19T23:00:00.000Z"
          ]
        },
        tooltip: {
          x: {
            format: "dd/MM/yy HH:mm"
          }
        }
      },

      examSeries: [
        {
          name: "Num of Students",
          data: [
            10,
            50,
            20,
            100,
            40,
            60,
            80,
            10,
            50,
            20,
            100,
            40,
            60,
            80,
            10,
            50,
            20,
            100,
            40,
            60,
            80,
            10,
            50,
            20
          ]
        }
      ],
      examChartOptions: {
        chart: {
          type: "area",
          stacked: false,
          height: 350,
          zoom: {
            type: "x",
            enabled: true,
            autoScaleYaxis: true
          },
          toolbar: {
            autoSelected: "zoom"
          }
        },
        dataLabels: {
          enabled: false
        },
        markers: {
          size: 0
        },
        title: {
          text: "",
          align: "left"
        },
        fill: {
          type: "gradient",
          gradient: {
            shadeIntensity: 1,
            inverseColors: false,
            opacityFrom: 0.5,
            opacityTo: 0,
            stops: [0, 90, 100]
          }
        },
        colors: ["#ffd31d"],
        yaxis: {
          labels: {
            formatter: function(val) {
              return val;
            }
          },
          title: {
            text: "Num of Students"
          }
        },
        xaxis: {
          type: "datetime",
          categories: [
            "2018-09-19T00:00:00.000Z",
            "2018-09-19T01:00:00.000Z",
            "2018-09-19T02:00:00.000Z",
            "2018-09-19T03:00:00.000Z",
            "2018-09-19T04:00:00.000Z",
            "2018-09-19T05:00:00.000Z",
            "2018-09-19T06:00:00.000Z",
            "2018-09-19T07:00:00.000Z",
            "2018-09-19T08:00:00.000Z",
            "2018-09-19T09:00:00.000Z",
            "2018-09-19T10:00:00.000Z",
            "2018-09-19T11:00:00.000Z",
            "2018-09-19T12:00:00.000Z",
            "2018-09-19T13:00:00.000Z",
            "2018-09-19T14:00:00.000Z",
            "2018-09-19T15:00:00.000Z",
            "2018-09-19T16:00:00.000Z",
            "2018-09-19T17:00:00.000Z",
            "2018-09-19T18:00:00.000Z",
            "2018-09-19T19:00:00.000Z",
            "2018-09-19T20:00:00.000Z",
            "2018-09-19T21:00:00.000Z",
            "2018-09-19T22:00:00.000Z",
            "2018-09-19T23:00:00.000Z"
          ]
        },
        tooltip: {
          x: {
            format: "dd/MM/yy HH:mm"
          }
        }
      },

    };
  }
};
</script>

<style lang="scss">
.page-card {
  box-shadow: 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  background: white;
  border-radius: 15px;
  transition: transform 0.3s ease-in-out;
}

.datetime {
  padding: 15px;
  box-shadow: 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  // box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  border-radius: 30px;
  text-align: center;
  transition: box-shadow 0.3s ease-in-out;
}

.datetime:hover {
  box-shadow: 1px 1px 5px 0 rgba(0, 0, 0, 0.19);
}

.selectCourse {
  height: auto;
  border: 0px;
  padding: 15px;
  box-shadow: 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  border-radius: 30px;
  text-align: center;
  transition: box-shadow 0.3s ease-in-out;
}

.selectCourse:hover {
  box-shadow: 1px 1px 5px 0 rgba(0, 0, 0, 0.19);
}

.progress-bar {
  box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.19);
  border-radius: 30px;
  background-color: rgba(255, 255, 255, 0.9);
}

.stat-num {
  box-shadow: 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  border-radius: 15px;
  transition: transform 0.3s ease-in-out;
}

.stat-num-top {
  background-image: linear-gradient(rgba(#0779e4, 0.7), rgba(#0779e4, 0.4));
  color: white;
}

.stat-num-corner {
  background-image: linear-gradient(rgba(#4cbbb9, 0.8), rgba(#4cbbb9, 0.5));
  color: white;
}

.stat-num-right {
  background-image: linear-gradient(rgba(#084177, 0.5), rgba(#084177, 0.3));
  color: white;
}

.stat-num:hover {
  // box-shadow: 1px 1px 5px 0 rgba(0, 0, 0, 0.19);
  // background-color: rgba(#0779e4, 0.4);
  transform: scale(1.05, 1.05);
}

.graph-card {
  box-shadow: 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  border-radius: 15px;
  transition: transform 0.3s ease-in-out;
}

.graph-card:hover {
  // box-shadow: 1px 1px 5px 0 rgba(0, 0, 0, 0.19);
  transform: scale(1.02, 1.02);
}
</style>